import React, { useEffect, useState, useRef } from 'react';
import { Col, Container, Form, Row, Button, Alert } from '@themesberg/react-bootstrap';
import { get, post } from '../../../services/back.service';
import { useNavigate } from "react-router-dom";


function FormGeneralInfo({ id, updateId, updateService, setVehicleclass, forceEnable = false, showSuccessMessage, showResponsable = false, validateHistoricPlate }) {
  const navigate = useNavigate();
  const updateServiceRef = useRef(updateService);
  const [disableForm, setdisableForm] = useState(false)
  const [showCriticalAlert, setShowCriticalAlert] = useState(false)
  const [data, setData] = useState({
    servicetype: [],
    vehicleclass: [],
    office: [],
    users: [],
  });
  const [infoGeneralForm, setInfoGeneralForm] = useState({
    placa: '',
    phone: '',
    office: '',
    applicant: '',
    service: '',
    insurance: '',
    client: '',
    id_client: '',
    email: '',
    vehicleclass: '',
    inspection_number: '',
    responsable_user: '',
  });
  const handleForm = ({ target }) => {
    if (target.name === 'vehicleclass' && !forceEnable) setVehicleclass(target.value)
    setInfoGeneralForm({ ...infoGeneralForm, [target.name]: target.value });
  };

  useEffect(() => {
    const getInfoBase = async () => {
      const respoInfo = await get('/peritaje/infoclientinspection/', {});
      if (respoInfo.success) {
        setData(respoInfo.data);
      } else {
        console.log(respoInfo.message);
      }
    };
    getInfoBase();
  }, []);

  useEffect(() => {
    const getInfoinspection = async () => {
      if (id && id !== "0") {
        const respoInfo = await get('/peritaje/infoinspection/' + id, {});
        if (respoInfo.success) {
          const infoGeneralForm = respoInfo.data;
          if (infoGeneralForm.crtical_plate) setShowCriticalAlert(true);
          setInfoGeneralForm({
            placa: infoGeneralForm.placa,
            phone: infoGeneralForm.phone,
            office: infoGeneralForm.office,
            applicant: infoGeneralForm.applicant,
            service: infoGeneralForm.service,
            insurance: infoGeneralForm.insurance,
            client: infoGeneralForm.client,
            id_client: infoGeneralForm.id_client,
            email: infoGeneralForm.email,
            vehicleclass: infoGeneralForm.vehicleclass,
            inspection_number: infoGeneralForm.inspection_number,
            responsable_user: infoGeneralForm.responsable_user,
          });
          setdisableForm(!forceEnable);
          if (!forceEnable) setVehicleclass(infoGeneralForm.vehicleclass)
          if (!forceEnable) updateServiceRef.current(infoGeneralForm.service)
          if (!forceEnable) updateId(id);
        }
      } else {
        setdisableForm(forceEnable);
        updateServiceRef.current(0);
        setShowCriticalAlert(false);
        setInfoGeneralForm({
          placa: '',
          phone: '',
          office: '',
          applicant: '',
          service: '',
          insurance: '',
          client: '',
          id_client: '',
          email: '',
          vehicleclass: '',
          inspection_number: '',
        })
      }
    }
    getInfoinspection();

  }, [id, updateId, forceEnable, setVehicleclass, updateServiceRef]);

  const sendInfo = async (event, service = 0) => {
    event.preventDefault();
    const body = { ...infoGeneralForm };
    const url = (forceEnable) ? `/peritaje/modifyprincipal/${id}` : '/peritaje/createinspection/';
    const respo = await post(url, body);
    if (respo.success) {
      setdisableForm(!forceEnable);
      if (!forceEnable) updateService(infoGeneralForm.service)
      const { data } = respo;
      if (!forceEnable) updateId(data.id);
      if (!forceEnable) navigate(`/modifyInspection/${data.encryptid}`);
      if (forceEnable) showSuccessMessage()
      validateHistoricPlate(data.id)
    }
  };



  return (
    <Container>
      <Form id='formgeneralinfo' onSubmit={(e) => sendInfo(e, infoGeneralForm.service)} >
        <Row className="mb-1">
          <Col>
            <h1 className="fw-bold">Informacion General</h1>
          </Col>
        </Row>
        {showCriticalAlert &&
          <Row>
            <Alert variant='danger'>Placa con reporte critico. por favor revisar</Alert>
          </Row>
        }
        <hr style={{ opacity: 0.1 }} />
        <Row>
          <Col xs={6} md={4}>
            <Form.Label htmlFor="placa">Placa</Form.Label>
            <Form.Control
              disabled={disableForm}
              type="text"
              name="placa"
              value={infoGeneralForm.placa}
              className="fw-bold text-uppercase"
              onChange={(e) => handleForm(e)}
              required
              maxLength={6}
            />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="office">Sucursal</Form.Label>
            <Form.Select
              disabled={disableForm}
              name="office"
              value={infoGeneralForm.office}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
              required
            >
              <option value="">Seleccione</option>
              {data.office.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="office">Clase</Form.Label>
            <Form.Select
              disabled={disableForm}
              name="vehicleclass"
              value={infoGeneralForm.vehicleclass}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
              required
            >
              <option value="">Seleccione</option>
              {data.vehicleclass.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="solicitante">Solicitado por</Form.Label>
            <Form.Control
              disabled={disableForm}
              type="text"
              name="applicant"
              className="fw-bold text-uppercase"
              value={infoGeneralForm.applicant}
              onChange={(e) => handleForm(e)}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="servicio">Tipo Servicio</Form.Label>
            <Form.Select
              disabled={disableForm}
              name="service"
              value={infoGeneralForm.service}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
              required
            >
              <option value="">Seleccione</option>
              {data.servicetype.map((element, i) => {
                return (
                  <option key={i} value={element.id}>
                    {element.name}
                  </option>
                );
              })}
            </Form.Select>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="aseguradora">Tipo Cliente</Form.Label>
            <Form.Select
              disabled={disableForm}
              name="insurance"
              value={infoGeneralForm.insurance}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
              required
            >
              <option value="">Seleccione</option>
              <option value="CONCESIONARIO">CONCESIONARIO</option>
              <option value="PARTICULAR">PARTICULAR</option>
            </Form.Select>
          </Col>
          {/* <Col xs={12} md={4}>
            <Form.Label htmlFor="aseguradora">Aseguradora</Form.Label>
            <Form.Control
              disabled={disableForm}
              type="text"
              name="insurance"
              className="fw-bold text-uppercase"
              value={infoGeneralForm.insurance}
              onChange={(e) => handleForm(e)}
              required
            />
          </Col> */}
          <Col xs={12} md={4}>
            <Form.Label htmlFor="cliente">Cliente</Form.Label>
            <Form.Control
              disabled={disableForm}
              type="text"
              name="client"
              className="fw-bold text-uppercase"
              value={infoGeneralForm.client}
              onChange={(e) => handleForm(e)}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="identificacion">Identificacion</Form.Label>
            <Form.Control
              disabled={disableForm}
              type="text"
              name="id_client"
              className="fw-bold text-uppercase"
              value={infoGeneralForm.id_client}
              onChange={(e) => handleForm(e)}
              required
            />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="correo">Correo</Form.Label>
            <Form.Control
              disabled={disableForm}
              type="email"
              name="email"
              value={infoGeneralForm.email}
              onChange={(e) => handleForm(e)}
              required
            />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="phone">Celular</Form.Label>
            <Form.Control
              disabled={disableForm}
              type="phone"
              name="phone"
              value={infoGeneralForm.phone}
              onChange={(e) => handleForm(e)}
            />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label htmlFor="correo">Codigo Peritaje</Form.Label>
            <Form.Control
              disabled={true}
              type="text"
              value={infoGeneralForm.inspection_number}
              readOnly
            />
          </Col>
          {showResponsable &&
            <Col xs={12} md={4}>
              <Form.Label htmlFor="correo">Responsable</Form.Label>
              <Form.Select
                disabled={disableForm}
                name="responsable_user"
                value={infoGeneralForm.responsable_user}
                onChange={(e) => handleForm(e)}
                aria-label="Default select example"
                required
              >
                <option value="">Seleccione</option>
                {data.users.map((element, i) => {
                  return (
                    <option key={i} value={element.id}>
                      {element.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Col>
          }
        </Row>
        <Row className="my-3">
          <Col className="d-flex justify-content-end">
            <Button type="submit" variant="primary" disabled={disableForm}>
              Guardar Informacion
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default FormGeneralInfo;
